import React, { useRef, useState } from 'react'
import { navigate } from 'gatsby'
import { StyledSearchContainer, StyledSearchForm, StyledSearchInput, StyledSearchIcon } from './SearchField.style'; 

import searchIcon from './search_icon.webp'

const SearchField = ({
  onSearch,
  visible = true,
  ...props
}) => {
  const [query, setQuery] = useState("")
  const searchRef = useRef(null)

  const submitSearch = (query) => {
    debugger
    if (!query) return

    const sPath = `/blog?search=${query}`
    setQuery('')
    navigate(encodeURI(sPath));
    if (onSearch) {
      onSearch(query)
    }
  }

  return (
    visible && <StyledSearchForm
      onSubmit={(event) => {
        event.preventDefault()
        submitSearch(query)
      }}
    >
      <StyledSearchContainer
        {...props}
      >
        <StyledSearchInput
          ref={searchRef}
          id="search"
          type="search"
          placeholder="Search posts..."
          value={query}
          autoComplete="off"
          onChange={(e) => setQuery(e.target.value)}
        />
        <StyledSearchIcon
          src={searchIcon}
          alt="Search"
          onClick={(e) => {
              e.preventDefault()
              searchRef.current.focus()
              submitSearch(e.target.value)
            }
          }
        />
      </StyledSearchContainer>
    </StyledSearchForm>
  )
}

export default SearchField;
